// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3-m3J","footer":"ModalInfo_footer__3d30x"};